<template>
  <div class="menu">
    <div class="menu-box">
      <div class="logo">
        <a :href="kitsUrl">
          <img src="@/assets/images/new_logo_horizontal.png"/>
        </a>
      </div>
      <div class="menu-items">
        <button class="button item-btn" style="width: 100%;margin: 21px 0;" v-on:click="toRegisterKit">
          Registrar
        </button>
        <router-link :to="kitsUrl" active-class="active" class="item">
          <font-awesome-icon :icon="['fa', 'box']"/>
          Meus Check-Ups
        </router-link>
        <!-- <router-link v-if="hasCarePlan" :to="carePlanUrl" active-class="active" class="item">
          <font-awesome-icon :icon="['fa', 'hand-holding-heart']"/>
          Plano de cuidado
        </router-link> -->
        <router-link :to="coordinatedCareUrl" active-class="active" class="item">
          <font-awesome-icon :icon="['fa', 'book-medical']"/>
          Cuidado Coordenado
        </router-link>
        <!-- <a href="https://www.clichealthid.com/" target="blank" class="item">
            <font-awesome-icon :icon="['fa', 'calendar-check']"/>
            Agendar consulta
        </a> -->
        <router-link v-if="examsQuantity > 0" :to="digitalUrl" active-class="active" class="item">
          <font-awesome-icon :icon="['fa', 'id-card']"/>
          Identidade de Saúde
        </router-link>
        <router-link :to="profileUrl" active-class="active" class="item">
          <font-awesome-icon :icon="['fa', 'user-tie']"/>
          Perfil
        </router-link>
        <a class="item" v-on:click.prevent="logout">
          <font-awesome-icon :icon="['fa', 'arrow-alt-circle-left']"/>
          Sair
        </a>
      </div>
    </div>
    <div class="menu-box-mobile">
      <div class="logo">
        <a :href="kitsUrl">
          <img src="@/assets/images/new_logo_horizontal.png"/>
        </a>
      </div>
      <div @click="switchDropdownMenu()" class="mobile-button">
        <button class="menu-mobile item-btn button" v-on:click.prevent="toRegisterKit">
          Registrar Kit
        </button>
        <font-awesome-icon class="dropdown-bars" :icon="['fa', 'bars']" v-if="!dropddownMenu"/>
        <font-awesome-icon class="dropdown-bars" :icon="['fa', 'times']" v-if="dropddownMenu"/>
      </div>
      <div class="menu-dropdown" v-bind:class="{ active: (dropddownMenu == true) }">
        <div class="menu-items">
          <button class="menu-desktop item-btn button" style="width: 88%;margin: 21px 0;"
                  v-on:click.prevent="toRegisterKit">
            Registrar Kit
          </button>
          <a :href="kitsUrl" class="item">
            <font-awesome-icon :icon="['fa', 'box']"/>
            Meus Check-Ups
          </a>
          <!-- <router-link v-if="hasCarePlan" :to="carePlanUrl" active-class="active" class="item">
            <font-awesome-icon :icon="['fa', 'hand-holding-heart']"/>
            Plano de cuidado
          </router-link> -->
          <router-link :to="coordinatedCareUrl" active-class="active" class="item">
          <font-awesome-icon :icon="['fa', 'book-medical']"/>
            Cuidado Coordenado
          </router-link>
          <!-- <a href="https://www.clichealthid.com/" target="blank" class="item">
            <font-awesome-icon :icon="['fa', 'calendar-check']"/>
            Agendar consulta
          </a> -->
          <a v-if="examsQuantity > 0" :href="digitalUrl" class="item">
            <font-awesome-icon :icon="['fa', 'id-card']"/>
            Identidade de Saúde
          </a>
          <a :href="profileUrl" class="item">
            <font-awesome-icon :icon="['fa', 'user-tie']"/>
            Perfil
          </a>
          <a class="item" v-on:click.prevent="logout">
            <font-awesome-icon :icon="['fa', 'arrow-alt-circle-left']"/>
            Sair
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {User} from '../../models/User'
    import {USER_LOGOUT} from '../../services/user'
    import { GET_RESULTS_COUNT } from '../../services/result'

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {
        faAddressBook,
        faBars,
        faTimes,
        faPlusCircle,
        faIdCard,
        faBox,
        faCalendarAlt,
        faChartBar,
        faFileAlt,
        faUserTie,
        faArrowAltCircleLeft,
        faCoins,
        faHandHoldingHeart,
        faBookMedical,
        faCalendarCheck
    } from '@fortawesome/free-solid-svg-icons'
    import {GET_CUSTOMER} from "../../services/customer";

    library.add(faBars);
    library.add(faTimes);
    library.add(faPlusCircle);
    library.add(faIdCard);
    library.add(faBox);
    library.add(faUserTie);
    library.add(faChartBar);
    library.add(faCalendarAlt);
    library.add(faFileAlt);
    library.add(faAddressBook);
    library.add(faArrowAltCircleLeft);
    library.add(faCoins);
    library.add(faHandHoldingHeart);
    library.add(faBookMedical);
    library.add(faCalendarCheck);

    export default {
        name: "side-menu",
        data() {
            return {
                modalRegisterKit: false,
                dropddownMenu: false,
                newKitUrl: 'cadastrar',
                profileUrl: 'perfil',
                kitsUrl: 'kits',
                digitalUrl: 'healthid-digital',
                carePlanUrl: 'care-plan',
                coordinatedCareUrl: 'coordinated-care',
                kitsUrl: 'kits',
                dashboardUrl: 'dashboard',
                schedulesUrl: 'agendamentos',
                resultsUrl: 'resultados',
                returnsUrl: 'devolutivas',
                examsQuantity: 0,
                hasCarePlan: false, 
            }
        },
        methods: {
            back() {
                this.$emit('back');
            },
            toRegisterKit() {
                let url_string = window.location.href;
                let url = new URL(url_string);
                let kit = url.searchParams.get("kit_number");
                if(!!kit && kit != '') this.$router.push(`/cadastrar-kit?kit_number=${kit}`);
                else this.$router.push('/cadastrar-kit')
                
            },
            switchDropdownMenu() {
                this.dropddownMenu = !this.dropddownMenu;
            },
            async examsQuant() {
                const data = await GET_RESULTS_COUNT();
                this.$store.state.examsQuantity = data.exams;
                this.examsQuantity = data.exams;
            },
            async logout() {
                try {
                    const response = await USER_LOGOUT();
                    let user = new User();
                    user.logout();
                } catch (error) {
                    console.log(error);
                }
            }
        },
        async mounted() {
          let customer = this.$store.state.user;
          if (!customer) {
            const resp = await GET_CUSTOMER();
            this.$store.commit('setUser', resp.customer);
            console.log("customer apos if", resp.customer);
          }
          if(!this.$store.state.examsQuantity){
            this.examsQuant();
          }else{
            this.examsQuantity = this.$store.state.examsQuantity;
          }

          if(!!this.$store.state.user.care_plan && !!this.$store.state.user.care_plan.documents) this.hasCarePlan = true;
        }
    }
</script>

<style scoped>
  @import "./menu.scss";
  @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/components/Menu/Menu.vue